import * as unorm from "unorm";
import validator from "validator";

/**
 * Trims and escapes special characters to their unicode value.
 * @param value the string value
 * @param flags for the cleaning process
 * @returns the cleaned string
 */
export function cleanString(value: string, flags?: { regex: boolean }) {
  const newFlags = { regex: false };
  if (flags) {
    Object.assign(newFlags, flags);
  }
  let newVal = validator.trim(value);
  if (newFlags.regex) {
    newVal = newVal.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
  }
  return newVal;
}

export function cleanFilename(str: string): string {
  return str.split("/").join("-");
}

// Trims, transforms to lower case and removes accents
// Remove all special characters to make it easier to sort and search
export function normalize(str: string): string {
  const term = (str || "").trim().toLowerCase();
  return unorm.nfd(term).replace(/[\u0300-\u036f]/g, "");
}

export function symbolsToTags(str: string): string {
  return (str || "").replace(/\r?\n/g, "<br>").replace(/\r/g, "<br>").replace(/\s/g, "&nbsp;");
}

export function toBase64Url(data: string): string {
  const b64Data = btoa(data);
  return b64Data.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

export function fromBase64Url(data: string): string {
  // Replace non-url compatible chars with base64 standard chars
  const input = data.replace(/-/g, "+").replace(/_/g, "/");

  // Pad out with standard base64 required padding characters
  /*const pad = input.length % 4;
    if (pad) {
        if (pad === 1) {
            throw new Error('InvalidLengthError: Input base64url string is the wrong length to determine padding');
        }
        input += new Array(5 - pad).join('=');
    }*/
  return atob(input);
}

const eqIgnoreCaseCmp = { sensitivity: "base" };
const innerEqualsIgnoringCase =
  "x".localeCompare("X", undefined, eqIgnoreCaseCmp) === 0
    ? (a: string, b: string) => a.localeCompare(b, undefined, eqIgnoreCaseCmp) === 0
    : (a: string, b: string) => a.toLowerCase().localeCompare(b.toLowerCase()) === 0;

export function equalsIgnoringCase(a?: string, b?: string): boolean {
  if (!a) return !b;
  if (!b) return false;
  return innerEqualsIgnoringCase(a, b);
}
